var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('calendarBreadcrumbs',{attrs:{"link":_vm.link,"linkAll":'bookingCalendarDate',"params":_vm.getDate()}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }